<template>
  <div v-if="show" class="race-standing">
    <div v-if="standingData.subTabs && standingData.subTabs.length > 1">
      <v-tabs v-model="tab" background-color="tabBackgroundColor" centered fixed-tabs show-arrows>
        <v-tab v-for="(subTab,index) in standingData.subTabs" active-class="is-active">
          <div class="raceTab">
            {{ subTab.tabText }}
          </div>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(subTab,index) in standingData.subTabs">
          <race-tab :standing-data="subTab" :key="index" :show="show" :user="user" :token="token"
                    :activeRegion="activeRegion" @switchRegion="switchRegion"/>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-if="standingData.subTabs && standingData.subTabs.length === 1">
      <race-tab :standing-data="standingData.subTabs[0]" key="zeroTab" :show="show" :user="user" :token="token"
                :activeRegion="activeRegion" @switchRegion="switchRegion"/>
    </div>
    <div v-if="standingData.subTabs && !standingData.subTabs.length">
      Please check back later for results.
    </div>
  </div>
</template>

<script>
import RaceTab from './RaceTab.vue'

export default {
  name: "RaceStanding",
  props: ["standingData", "show", "user", "token", "activeRegion"],
  components: {
    RaceTab
  },
  mounted() {
    console.log(this.standingData)
  },
  watch: {
    standingData(newVal, oldVal) {
      console.log("Standing Data", this.standingData)
    }
  },
  data() {
    return {
      tab: null
    }
  },
  methods: {
    switchRegion(region) {
      this.$emit('switchRegion', region)
    }
  }
}
</script>

<style>
.race-standing .v-tabs-slider-wrapper {
  display: none !important;
}
</style>
<style scoped>
.raceTab {
  text-transform: none !important;
}
.v-tab {
  height: 40px;
  border: 1px solid rgb(219, 219, 219);
}

.tabBackgroundColor {
  background-color: #e9ebee !important;
}

.is-active {
  background-color: #4267b2 !important;
  color: #FFF !important;
}

.is-active::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 7px solid #e9ebee;
  bottom: -1px;
  left: 50%;
  margin-left: -8px;
  position: absolute;
  z-index: 1;
}
</style>